import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";

import { Col, Container, Row } from "react-bootstrap";
import useAuth from "../../hooks/useAuth";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
// import 'boxicons/css/boxicons.min.css';
// import "./Admin.css";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import TopBar from "./TopBar";

const GetBooking = () => {
  const navigate = useNavigate();
  const handleRedirect = () => {
    navigate("/GetBookConsignmentByDate");
  }
  const { auth } = useAuth();
  const { bookingId } = useParams(); // Get the bookingId from the URL
  const GETBOOKING_URL = "api/get-booking";
  const axiosPrivate = useAxiosPrivate();
  const [bookings, setBookings] = useState([]); // To store list of users
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const headers = {
        "Content-Type": "application/json",
      };
      const data = {


        booking_id: bookingId,
      };

      try {

        const response = await axiosPrivate.get(GETBOOKING_URL, {
          params: data,
          headers,
          withCredentials: true, // Ensures cookies are sent with the request if needed
        });

        setBookings(response.data); // Store the fetched data into the user state
        setLoading(false); // Stop loading spinner
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load data");
        setLoading(false); // Set loading to false even if there is an error
      }
    };

    fetchData();
  }, []);

  const [showModal, setShowModal] = useState(false);
  const [selectedDimensions, setSelectedDimensions] = useState([]);
  const [selectedConsignmentId, setSelectedConsignmentId] = useState(null);

  const handleShowModal = (consignment) => {
    setSelectedDimensions(consignment.dimensions || []);
    setSelectedConsignmentId(consignment.consignment_id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedDimensions([]);
    setSelectedConsignmentId(null);
  };


  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }



  return (
    <>

      <section className="bookbody">
        <br />
        <div className="wrapperbook">
          {/* <button type="button" className="btn btn-success backbtn" onClick={() => navigate(-1)}>back</button> */}
          <button onClick={handleRedirect} type="button" className="btn btn-success ms-auto d-block top-bt">
            Consignment List
          </button>
          {/* <center><img src="/images/box.png" width="15%" className='adm-img' /></center> */}
          <h3>Consignment Booking Details</h3>


          <Row>
            <Col>
              <p><span className="empspan">Booking ID :</span> {bookings.booking_id}</p>
            </Col>
            <Col>
              <p><span className="empspan">Franchise ID :</span> {bookings.franchise_id}</p>
            </Col>
            <Col>
              <p><span className="empspan">Booking Date :</span> {bookings.booking_date}</p>
            </Col>
          </Row>

          <Row>

            <Col>
              <p><span className="empspan">Payment Mode :</span> {bookings.payment_mode}</p>
            </Col>
            <Col>
              <p><span className="empspan">Customer ID :</span> {bookings.customer_id}</p>
            </Col>
            <Col>
              <p><span className="empspan">Consigner Name :</span> {bookings.consigner_name}</p>
            </Col>
          </Row>

          <Row>
            <Col>
              <p><span className="empspan">Consigner Address1 :</span> {bookings.consigner_address1}</p>
            </Col>
            <Col>
              <p><span className="empspan">Consigner Address2 :</span> {bookings.consigner_address2}</p>
            </Col>
            <Col>
              <p><span className="empspan">Consigner Pincode :</span> {bookings.consigner_pincode}</p>
            </Col>
          </Row>




          <Row>

            <Col>
              <p><span className="empspan">Consigner City :</span> {bookings.consigner_city}</p>
            </Col>
            <Col>
              <p><span className="empspan">Consigner Mobile :</span> {bookings.consigner_mobile}</p>
            </Col>
            <Col>
              <p><span className="empspan">Net Amount :</span> {bookings.net_amount}</p>
            </Col>
          </Row>



          <Row>
            <Col>
              <p><span className="empspan">Total GST :</span> {bookings.total_gst}</p>
            </Col>
            <Col>
              <p><span className="empspan">Other Charges :</span> {bookings.other_charges}</p>
            </Col>
            <Col>
              <p><span className="empspan">Service type :</span> {bookings.service_type}</p>
            </Col>

          </Row>
          <Row>

            <Col>
              <p><span className="empspan">Delivery mode :</span> {bookings.delivery_mode}</p>
            </Col>
            <Col>
              <p><span className="empspan">Booking type :</span> {bookings.booking_type}</p>
            </Col>
            <Col>
              <p><span className="empspan">Delivery mode :</span> {bookings.delivery_mode}</p>
            </Col>
          </Row>
        </div>
      </section>

      <section

        style={{
          alignItems: "center",
          background: "#fff",
          backgroundSize: "cover",
          backgroundPosition: "center",
          maxWidth: "100%",
          borderRadius: "10px",
          marginTop: "2%",
        }}
      >
        <div className="wrapper7 ">
          <table border="1" id="customers">
            <thead>
              <tr>
                <th>ID</th>
                <th>AWB</th>
                <th>Type</th>
                <th>Ship Mode</th>
                <th>Consignee Name and Mobile</th>
                <th>Consignee Address</th>
                <th>Destination Franchise</th>
                <th>Sector</th>
                <th>Goods Name</th>
                <th>Goods Value</th>
                <th>eway bill nos</th>
                <th>Quantity</th>
                <th>Weight</th>
                <th>Volume</th>
                <th>Amount</th>
                <th>GST</th>
                <th>Other charges</th>
                <th>Current status</th>




                {(bookings.delivery_mode === "FOV OR" ||
                  bookings.delivery_mode === "FOV CR") && (
                    <th>FOV</th>
                  )}

                {(bookings.delivery_mode === "TOPAY") && (
                  <th>TOPAY</th>
                )}

                {(bookings.delivery_mode === "OBD") && (
                  <th>OBD</th>
                )}
                {(bookings.delivery_mode === "COD") && (
                  <th>COD</th>
                )}
                <th>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {bookings.consignments.map((consignment) => (
                <tr key={consignment.consignment_id}>
                  <td>{consignment.consignment_id}</td>
                  <td>{consignment.awb_number}</td>
                  <td>{consignment.consignment_type}</td>
                  <td>{consignment.shipping_mode}</td>
                  <td>{consignment.consignee_name} - {" "}{consignment.consignee_mobile}</td>
                  <td>
                    {consignment.consignee_address1}, {consignment.consignee_address2},{" "}
                    {consignment.consignee_city}, {consignment.pincode}
                  </td>
                  <td>
                    {consignment.destination_franchise_name} -{" "}
                    {consignment.destination_franchise_code}
                  </td>
                  <td>{consignment.sector}</td>
                  <td>{consignment.goods_name}</td>
                  <td>{consignment.goods_value}</td>
                  <td>{consignment.eway_bill_nos}</td>
                  <td>{consignment.pieces}</td>
                  <td>{consignment.weight}
                  </td>
                  <td onClick={() => handleShowModal(consignment)}>
                    {Array.isArray(consignment.dimensions)
                      ? consignment.dimensions.reduce(
                        (total, d) =>
                          total + (Number(d.length || 0) * Number(d.breadth || 0) * Number(d.height || 0)),
                        0
                      ).toFixed(2)
                      : "0.00"}
                    <br />
                    <span

                      style={{ cursor: "pointer", color: "#007bff" }}
                    >
                      <i className="bx bx-info-circle"></i>
                    </span>
                  </td>


                  <td>{consignment.amount}</td>
                  <td>{consignment.gst}</td>
                  <td>{consignment.other_charges}</td>
                  <td>{consignment.current_status}</td>

                  {(bookings.delivery_mode === "FOV OR" ||
                    bookings.delivery_mode === "FOV CR") && (
                      <td>{consignment.fov_value}</td>

                    )}


                  {(bookings.delivery_mode === "TOPAY") && (
                    <td>{consignment.topay_value}</td>
                  )}
                  {(bookings.delivery_mode === "OBD") && (
                    <td>{consignment.obd_value}</td>
                  )}
                  {(bookings.delivery_mode === "COD") && (
                    <td>{consignment.cod_value}</td>
                  )}



                  <td>{consignment.remarks}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>


      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Dimensions - Consignment #{selectedConsignmentId}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDimensions.length > 0 ? (
            <table className="table table-bordered text-center">
              <thead>
                <tr>
                  <th>Sl No</th>
                  <th>Length</th>
                  <th>Breadth</th>
                  <th>Height</th>
                  <th>Volume</th>
                </tr>
              </thead>
              <tbody>
                {selectedDimensions.map((dim, index) => (
                  <tr key={index}>
                    <td>{dim.slno}</td>
                    <td>{dim.length}</td>
                    <td>{dim.breadth}</td>
                    <td>{dim.height}</td>
                    <td>{(dim.length * dim.breadth * dim.height).toFixed(2)}</td>
                  </tr>
                ))}

                {/* ✅ Add total row */}
                <tr className="fw-bold table-info">
                  <td colSpan="4">Total Volume</td>
                  <td>
                    {selectedDimensions
                      .reduce(
                        (total, d) =>
                          total + (Number(d.length || 0) * Number(d.breadth || 0) * Number(d.height || 0)),
                        0
                      )
                      .toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <p>No dimensions available for this consignment.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-danger" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      <TopBar />
    </>
  );
};

export default GetBooking;
